export const SET_HABITAT = 'SET_HABITAT';
export const UNSET_HABITAT = 'UNSET_HABITAT';
export const SET_HABITAT_LIKED = 'SET_HABITAT_LIKED';
export const SET_HABITAT_PROPS = 'SET_HABITAT_PROPS';
export const SET_HABITAT_STREAM_STARTED = 'SET_HABITAT_STREAM_STARTED';
export const SET_SELECTED_CAMERA = 'SET_SELECTED_CAMERA';
export const UPDATE_AVAILABLE_CAMERAS = 'UPDATE_AVAILABLE_CAMERAS';
